/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { MedicalAssessMent } from 'app/shared/model/enumerations/medical-assess-ment.model';
import { MedicalCondition } from 'app/shared/model/enumerations/medical-condition.model';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-addl-assessment.reducer';

export const PreOpAddlAssessmentUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const preOpAddlAssessmentEntity = useAppSelector(state => state.preOpAddlAssessment.entity);
  const loading = useAppSelector(state => state.preOpAddlAssessment.loading);
  const updating = useAppSelector(state => state.preOpAddlAssessment.updating);
  const updateSuccess = useAppSelector(state => state.preOpAddlAssessment.updateSuccess);
  const medicalAssessMentValues = Object.keys(MedicalAssessMent);
  const medicalConditionValues = Object.keys(MedicalCondition);

  const handleClose = () => {
    navigate(`/pre-op-addl-assessment${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpAddlAssessmentEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      reviewedBy: doctors.find(it => it.id.toString() === values.reviewedBy?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          medicalAssessment: 'HIGH',
          medicalCondition: 'CONTROLLED',
          ...preOpAddlAssessmentEntity,
          surgery: preOpAddlAssessmentEntity?.surgery?.id,
          reviewedBy: preOpAddlAssessmentEntity?.reviewedBy?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpAddlAssessment.home.createOrEditLabel" data-cy="PreOpAddlAssessmentCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpAddlAssessment.home.createOrEditLabel">
              Create or edit a PreOpAddlAssessment
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-addl-assessment-id"
                  label={translate('tinyMedicRestApp.preOpAddlAssessment.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.history')}
                id="pre-op-addl-assessment-history"
                name="history"
                data-cy="history"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.clinicalFindings')}
                id="pre-op-addl-assessment-clinicalFindings"
                name="clinicalFindings"
                data-cy="clinicalFindings"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.specificInvestigations')}
                id="pre-op-addl-assessment-specificInvestigations"
                name="specificInvestigations"
                data-cy="specificInvestigations"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.medicalAssessment')}
                id="pre-op-addl-assessment-medicalAssessment"
                name="medicalAssessment"
                data-cy="medicalAssessment"
                type="select"
              >
                {medicalAssessMentValues.map(medicalAssessMent => (
                  <option value={medicalAssessMent} key={medicalAssessMent}>
                    {translate(`tinyMedicRestApp.MedicalAssessMent.${medicalAssessMent}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.medicalAssessmentNotes')}
                id="pre-op-addl-assessment-medicalAssessmentNotes"
                name="medicalAssessmentNotes"
                data-cy="medicalAssessmentNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.medicalCondition')}
                id="pre-op-addl-assessment-medicalCondition"
                name="medicalCondition"
                data-cy="medicalCondition"
                type="select"
              >
                {medicalConditionValues.map(medicalCondition => (
                  <option value={medicalCondition} key={medicalCondition}>
                    {translate(`tinyMedicRestApp.MedicalCondition.${medicalCondition}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.medicalConditionNotes')}
                id="pre-op-addl-assessment-medicalConditionNotes"
                name="medicalConditionNotes"
                data-cy="medicalConditionNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.instructions')}
                id="pre-op-addl-assessment-instructions"
                name="instructions"
                data-cy="instructions"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.active')}
                id="pre-op-addl-assessment-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.cursor')}
                id="pre-op-addl-assessment-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.lastupdated')}
                id="pre-op-addl-assessment-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.microSec')}
                id="pre-op-addl-assessment-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAddlAssessment.timestampentry')}
                id="pre-op-addl-assessment-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pre-op-addl-assessment-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpAddlAssessment.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-addl-assessment-reviewedBy"
                name="reviewedBy"
                data-cy="reviewedBy"
                label={translate('tinyMedicRestApp.preOpAddlAssessment.reviewedBy')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-addl-assessment" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpAddlAssessmentUpdate;
